import { render, staticRenderFns } from "./SifcopForm.vue?vue&type=template&id=48351502&scoped=true"
import script from "./SifcopForm.vue?vue&type=script&lang=js"
export * from "./SifcopForm.vue?vue&type=script&lang=js"
import style0 from "./SifcopForm.vue?vue&type=style&index=0&id=48351502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48351502",
  null
  
)

export default component.exports